import { TheftRecoveryCardModel } from "./model/index.js";
import { TheftRecoveryCard } from "./viewer/index.js";
export default {
  install(molten) {
    molten.addPlugin('DashboardItem', {
      type: TheftRecoveryCardModel.TYPE,
      viewer: TheftRecoveryCard,
      model: TheftRecoveryCardModel,
      name: 'Theft Recovery Mode',
      objectType: 'assetLocators'
    });
  }
};